export const handleToggle = (setState) => {
    setState((prevState) => !prevState)
}